import React from 'react';
import Navigation from './Navigation';
import './home.css'; 
import contact from '../src/contact_marketserve.jpg'


function Contact() {
  return (
    <div>
      <Navigation />
      <div className="main-content ">
        <div className="text-content">
        <section className="contact-section">
        <h2>Contact Us</h2>
        <p> We welcome your inquiries and appreciate the opportunity to assist you. 
            Feel free to reach out for any questions or assistance.</p>
        <div className="contact-details">
          <p>Email: <a href="mailto:info@cloudservesystems.com">info@cloudservesystems.com</a></p>
          <p>Phone: +91 760 000 2540</p>
        </div>
      </section>
         
         </div>
        <div className="image-content">
          <img
            src={contact} style={{width:'500px'}}
            alt="New Image Alt Text"
          />
        </div>
      </div>
      <br/> <br/>

<br/>
      <section className="footer">
        <h4>Address</h4>
        <p>
          A-103, Madhuram Tower
          Opp .St Kabir School, Naranpura
          Ahmedabad-380013, India
        </p>

        <div className="icons">
          +91 760 000 2540<br />
          <div className="Policy">
            <a href="/privacy-policy.html" style={{ color: 'black' }} target="_blank"><b>Privacy Policy</b></a> &nbsp;
            {/* <a href="/term_conditions.html" style={{ color: 'black' }} target="_blank"><b>Terms of Use</b></a> */}
          </div>
          {/* <i className="fa-solid fa-envelope"></i>info@cloudservesystems.com<br/>
          <i className="fa-solid fa-envelope"></i>sales@cloudservesystems.com<br/>
          <i className="fa-solid fa-envelope"></i>support@cloudservesystems.com */}
        </div>
        <p>Copyright @2017 Cloudserve Systems Pvt. Ltd. All rights reserved. </p>
      </section>
    </div>
  );
}

export default Contact;
